import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "../app/store"; // Assuming RootState is the type for the entire Redux store
import { closeAllModals, closeModal } from "../features/modalSlice"; // Path to your modal slice
import ModalCreateFolder from "../modals/ModalCreateFolder";
import ModalRenameChat from "../modals/ModalRenameChat";
import ModalSearch from "../modals/ModalSearchChat";
import ModalShareLink from "../modals/ModalShareLink";
import ModalGiveFeedback from "../modals/ModalGiveFeedback";

const ModalManager: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  // Select modals and props from Redux
  const modals = useSelector((state: RootState) => state.modal.modals);
  const modalProps = useSelector((state: RootState) => state.modal.props);
  // console.log("redux   modalProps >> ",modalProps);

  // Close all modals on route change
  useEffect(() => {
    dispatch(closeAllModals());
  }, [location.pathname, dispatch]);

  useEffect(() => {
    console.log("modalProps",modalProps);
  }, [modalProps]);
  return (
    <>
      {modals.ModalSearchChat && <ModalSearch />}
      {modals.ModalCreateFolder && <ModalCreateFolder />}
      {modals.ModalShareLink && (
        <ModalShareLink
        // onClose={() => dispatch(closeModal("ModalShareLink"))}
        />
      )}
      {modals.ModalGiveFeedback && (
        <ModalGiveFeedback
          onClose={() => dispatch(closeModal("ModalGiveFeedback"))}
          msg_id={modalProps.msg_id ?? 0}
          user_id={modalProps.user_id ?? 0}
          chat_id={modalProps.chat_id ?? 0}
          buttonId={modalProps.buttonId ?? ""}
        />
      )}

      {modals.ModalRenameChat && (
        <ModalRenameChat
          folder_id={modalProps.id ?? 0}
          type={modalProps.type ?? "chat"}
          name={modalProps.name ?? ""}
        />
      )}
    </>
  );
};

export default ModalManager;
